import React from 'react';
import { Field } from 'redux-form';
import PropTypes from 'prop-types';
import Modal from '../../components/Modal/Modal';
import REGISTRATION_FIELDS from './constants';
import * as styles from './RegistrationContainer.scss';

class RegistrationConfirmPhoneModal extends React.Component {
  render() {
    const {
      isOpen,
      onClose,
      translate,
      phone,
      children,
      renderInput,
      validateInputValue
    } = this.props;
    return (
      <Modal isOpen={isOpen} className={styles.modal} onRequestClose={onClose}>
        <div className={styles.modalContentWrapper}>
          <p className={styles.modalTitle}>
            {translate('authenticationPage', 'confirm_phone_number')}
          </p>
          <div className={styles.modalSubTitleWrapper}>
            <p className={styles.modalSubTitle}>
              {translate('authenticationPage', 'confirmation_code_sent')}
            </p>
            <p className={styles.modalPhoneNumber}>{phone}</p>
            <p className={styles.modalSubTitle}>
              {translate('authenticationPage', 'enter_code_below')}
            </p>
          </div>
          <div className={styles.codeFieldWrapper}>
            <Field
              name={REGISTRATION_FIELDS.CODE}
              type="text"
              maxLength="4"
              component={renderInput}
              validate={validateInputValue}
              placeholder={translate('authenticationPage', 'code')}
            />
          </div>
          {children}
        </div>
      </Modal>
    );
  }
}

RegistrationConfirmPhoneModal.propTypes = {
  isOpen: PropTypes.bool,
  onClose: PropTypes.func,
  translate: PropTypes.func,
  phone: PropTypes.string,
  renderInput: PropTypes.func,
  validateInputValue: PropTypes.func,
  children: PropTypes.node
};

export default RegistrationConfirmPhoneModal;
